import { AxiosInstance } from 'axios';
import { classToPlain } from 'class-transformer';
import { BaseService } from 'yellowfin-ui-lib';
import { Address, Customer, ResetToken } from 'yf-commerce-model-ui-lib';

export class CustomerService extends BaseService {

    constructor(http: AxiosInstance) {
        super(http);
    }

    signup(customer: Customer, address: Address): Promise<Customer> {
        return this.mapResponse(this.http.post(`/ws/access/customer/signup`, classToPlain(customer)), Customer);
    }

    forgotPassword(email: string): Promise<any> {
        return this.http.post(`/ws/access/customer/resetpwd`, { email });
    }

    validateToken(t: string): Promise<ResetToken> {
        return this.mapResponse(this.http.get(`/ws/access/resetform/${t}`), ResetToken);
    }

    changePassword(user: number, password: string, tokenOneTime: string): Promise<Customer> {
        return this.mapResponse(this.http.post(`/ws/access/customer/${user}/password`, { password, token: tokenOneTime }), Customer);
    }
}
